import React from "react";
import PatientDetails from "./PatientDetails";
import PreviousVisit from "./PreviousVisit";
import CurrentVisit from "./CurrentVisit";
import WorkPlan from "./WorkPlan";

const PlanningCell = (props) => {
  const { record, index } = props;
  return (
    <div className={index % 2 === 0 ? "even" : "odd"}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 0 10px 0",
        }}
      >
        <PatientDetails patient={record.patient} />
        <PreviousVisit record={record} />
        <CurrentVisit record={record} />
      </div>
      <div className="innerCell">
        <WorkPlan recurrentEvents={record.recurrent_work_events} />
      </div>
    </div>
  );
};

export default PlanningCell;
